import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchAllSites = async () => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/sites/all`);
  const sites = await result.json();
  return sites;
};

export default fetchAllSites;
